/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AudioTrigger from "../Audio/AudioTrigger";

 /** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass('MusicalBangupInfo')
export default class MusicalBangupInfo
{
    @property(cc.Float)
    public Ratio: number = 0.0;

    @property(cc.Float)
    public Duration: number = 0.0;

    @property(AudioTrigger)
    public AudioTrigger: AudioTrigger = null;
}
